import React from "react";
import { Shell } from "@/components/shell";
import { Heading } from "@/components/ui/heading";
import SEO from "@/components/SEO";

export default function ImpressumPage() {
  return (
    <>
      <SEO title="Impressum" description="Impressum und rechtliche Informationen zu SpeiseGuru." />
      <Shell>
      <div className="container px-4 py-8 mx-auto max-w-4xl">
        <Heading title="Impressum" description="Informationen zum Betreiber dieser Webseite" />
        
        <div className="mt-8 space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Angaben gemäß § 5 TMG</h2>
            <p>[Ihr Name]</p>
            <p>[Straße Nr.]</p>
            <p>[PLZ Ort]</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Kontakt</h2>
            <p>Telefon: [Ihre Telefonnummer]</p>
            <p>E-Mail: [Ihre E-Mail-Adresse]</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
            <p>[Ihre USt-IdNr., falls vorhanden]</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>[Ihr Name]</p>
            <p>[Straße Nr.]</p>
            <p>[PLZ Ort]</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:underline ml-1"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-2">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mb-2">Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="pb-6">
            <p className="text-sm mt-4">
              Quelle: <a href="https://www.e-recht24.de" className="text-primary hover:underline">eRecht24</a>
            </p>
          </section>
        </div>
      </div>
    </Shell>
    </>
  );
}